<template>
  <div>
    <b-form-group
      v-if="showType == 'form-builder'"
      :description="properties.description"
      :label="properties.label"
      :style="properties.style"
    >
      <b-form-input :placeholder="properties.placeholder"></b-form-input>
    </b-form-group>
    <div v-if="showType == 'properties'">
      <text-input-v1-properties :formId="formId" />
    </div>
    <b-form-group
      style="font-size: 14px"
      v-if="
        showType == 'form-submitter' ||
          (showType == 'e-form' && properties.eFormEditable)
      "
      :description="
        computedConditions.description
          ? superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'description',
              value: properties.description,
              defaultValue: '',
              form: this.form
            })
          : properties.description
      "
      :style="properties.style"
      v-show="!computedHidden"
      :state="state"
      :invalid-feedback="errors.join(', ')"
    >
      <template v-slot:label>
        <div class="d-flex justify-content-between align-items-center">
          <div>
            {{ computedConditions.label
            ? superComputeFormSubmitterValue({
                elementId: this.id,
                property: 'label',
                value: properties.label,
                defaultValue: '',
                form: this.form
              })
            : properties.label }}
          </div>
          <div v-if="config.serverSegment == 'core'">
            <b-dropdown text="" variant="link" size="sm" no-caret ref="responsesDropdown">
              <template #button-content>
                <i class="fas fa-ellipsis-v text-secondary"></i>
              </template>
              <b-dropdown-form>
                <div class="dropdown-item hover-pointer" :disabled="!localValue" style="font-size: 14px;" @click="saveResponse"><i class="fas fa-save mr-2"></i>Save value</div>              
                <div class="px-2" style="padding: 14px; font-size: 14px; background-color: #f4f7fb">
                  Load value:
                </div>
              </b-dropdown-form>
              <div class="dropdown-item hover-pointer" v-for="s in savedResponses" :key="s.id" @click="writeResponse(s.response)">
                <div class="d-flex flex-row align-items-center justify-content-between" style="font-size: 14px;">                  
                  <div class="mr-3" style="white-space: normal"><i class="fas fa-clone mr-2"></i>{{ s.response }}</div>
                  <i class="fas fa-trash text-danger" :style="{ visibility: s.isPredefined ? 'hidden' : 'visible' }" @click.stop="deleteResponse(s.id)"></i>
                </div>
              </div>
            </b-dropdown>
          </div>
        </div>
      </template>
      <b-form-input
        style="font-size: 14px"
        :placeholder="
          computedConditions.placeholder
            ? superComputeFormSubmitterValue({
                elementId: this.id,
                property: 'placeholder',
                value: properties.placeholder,
                defaultValue: '',
                form: this.form
              })
            : properties.placeholder
        "
        :readonly="
          computedConditions.readonly
            ? superComputeFormSubmitterValue({
                elementId: this.id,
                property: 'readonly',
                value: properties.readonly,
                defaultValue: false,
                form: this.form
              })
            : properties.readonly
        "
        :required="
          computedConditions.required
            ? superComputeFormSubmitterValue({
                elementId: this.id,
                property: 'required',
                value: properties.required,
                defaultValue: false,
                form: this.form
              })
            : properties.required
        "
        v-model="localValue"
        @blur="controlValue = localValue"
        :state="state"
      ></b-form-input>
    </b-form-group>
    <b-form-group
      v-if="
        showType == 'form-viewer' ||
          (showType == 'e-form' && !properties.eFormEditable)
      "
      :label="
        computedConditions.label
          ? superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'label',
              value: properties.label,
              defaultValue: '',
              form: this.form
            })
          : properties.label
      "
    >
      {{ controlValue }}
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import TextInputV1Properties from "./TextInputV1Properties.vue";
import savedResponseServer from "../../../../server/userResponse";
import config from "../../../../server/serverCfg";

export default {
  name: "TextInputV1",
  components: { TextInputV1Properties },
  props: ["showType", "properties", "form", "id", "results", "formId"],
  data() {
    return {
      computedProperties: [
        "description",
        "label",
        "hidden",
        "placeholder",
        "readonly",
        "required",
        "responseOptions"
      ],
      computedConditions: {},
      value: "",
      localValue: "",
      savedResponses: [],
      config: config
    };
  },
  mounted() {
    if (
      !this.getFormSubmitterComponentValue(this.id) &&
      (this.showType == "form-submitter" || this.showType == "e-form")
    ) {
      this.setFormSubmitterComponentValue({
        controlId: this.id,
        controlValue:
          typeof this.properties.value == "string" &&
          this.properties.value.includes("{{")
            ? this.superComputeFormSubmitterValue({
                elementId: this.id,
                property: "value",
                value: this.properties.value,
                defaultValue: "",
                form: this.form
              })
            : this.properties.value
      });
    }
    this.localValue = this.controlValue;
    if (this.showType == "form-submitter" || this.showType == "e-form") {
      this.setFormSubmitterComponentMetadata({
        controlId: this.id,
        controlMetadata: {
          label: this.properties.label
        }
      });
      this.getAllResponses();
    }

    this.computeConditions();
  },
  methods: {
    ...mapMutations("formSubmitter", [
      "setFormSubmitterComponentValue",
      "setFormSubmitterComponentMetadata"
    ]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm[this.id]
        ? this.computedPropertiesForm[this.id][property]
          ? this.computedPropertiesForm[this.id][property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
        
      return `
      <fieldset aria-describedby="" class="form-group">
        <legend style="font-size: 14px" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div style="font-size: 14px" tabindex="-1" role="group" class="bv-no-focus-ring">
          ${this.controlValue}
        </div>
      </fieldset>`;
    },
    async saveResponse(e) {
      if (this.currentFormId == "previewForm") return;
      e.stopPropagation()
      if(this.localValue.trim() && !this.savedResponses.find(r => r.response.trim() == this.localValue.trim())) {
        await savedResponseServer.create({
          formId: this.currentFormId,
          componentId: this.id,
          response: this.localValue,
        });
        await this.getAllResponses();
        this.updatePopper();
      }
      
    },
    updatePopper() {
      this.$refs.responsesDropdown.updatePopper();
    },
    async deleteResponse(id){
      await savedResponseServer.delete(id);
      await this.getAllResponses();
      this.updatePopper();
    },
    async getAllResponses(){
      const responses = this.currentFormId == "previewForm" ? [] : await savedResponseServer.query(this.currentFormId, this.id);
      const predefinedOptions = this.predefinedOptions() ?? [];
      this.savedResponses = predefinedOptions.map(p => ({
          response: p,
          isPredefined: true
        })).concat(responses);
    },
    writeResponse(response){
      this.controlValue = response;
    },
    predefinedOptions() {
      const responseOptions = this.computedConditions.responseOptions
        ? this.superComputeFormSubmitterValue({
            elementId: this.id,
            property: "responseOptions",
            value: this.properties.responseOptions,
            defaultValue: [],
            form: this.form
          })
        : this.properties.responseOptions;
      return responseOptions;  
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      formErrors: state => state.form.errors,
      currentFormId: state => state.form.id
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue",
      "superComputeFormSubmitterValue",
      "computeFormSubmitterValue"
    ]),
    ...mapState("formSubmitter", {
      computedPropertiesForm: state => {
        return state.form.computedProperties;
      }
    }),
    controlValue: {
      get() {
        if (this.results) return this.results[this.id];
        return this.getFormSubmitterComponentValue(this.id);
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newControlValue,
            userAction: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    errors: {
      get() {
        return this.formErrors[this.id] ? this.formErrors[this.id] : [];
      }
    },
    state: {
      get() {
        return this.errors.length == 0 ? null : false;
      }
    },
    computedHidden(){
      const hiddenValue = this.computedConditions.hidden
        ? this.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'hidden',
            value: this.properties.hidden,
            defaultValue: false,
            form: this.form
          })
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  },
  watch: {
    controlValue(newValue) {
      if (newValue != this.localValue) {
        this.localValue = newValue;
      }
    }
  }
};
</script>

<style scoped>
>>> .dropdown-menu {
  width: max-content;
  max-height: 300px;
  max-width: 500px;
  overflow-y: auto;
}

>>> .dropdown-item {
  padding: 0.25rem 0.5rem;
}
</style>
